import Quill from 'quill'
import type { ToastServiceMethods } from 'primevue'

export default defineNuxtPlugin(async () => {
  interface AIModuleOptions {
    project:
      | components['schemas']['Project']
      | components['schemas']['Email']['project']
    toast: ToastServiceMethods
  }

  function AIModule(quill: Quill, options: AIModuleOptions) {
    const toolbar = quill.getModule('toolbar')
    const button = document.createElement('button')

    button.innerText = 'AI'
    button.type = 'button'

    // @ts-expect-error - Quill toolbar container type is not properly exposed in type definitions
    toolbar.container.appendChild(button)

    button.addEventListener('click', async function () {
      if (!options.project) return

      const range = quill.getSelection()

      if (!range) {
        options.toast.add({
          severity: 'error',
          detail: 'Please select some text to be rewritten',
          summary: 'Error',
        })
        return
      }

      const content = quill.getText(range.index, range.length)

      if (!content) {
        options.toast.add({
          severity: 'error',
          detail: 'Please select some text to be rewritten',
          summary: 'Error',
        })
        return
      }

      button.innerText = '⏳'
      button.disabled = true

      const { $api } = useNuxtApp()
      await $api<components['schemas']['Rewrite']>('/ai/rewrites/', {
        method: 'POST',
        body: { project: options.project.id, original_content: content },
      })
        .then((response) => {
          if (!response.new_content) return
          quill.setText(response.new_content)
        })
        .catch((error) => processFormErrors(error, options.toast))
        .finally(() => {
          button.innerText = 'AI'
          button.disabled = false
        })
    })
  }

  Quill.register('modules/ai', AIModule)
})
